import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface QueryItem {
  id: string;
  name: string;
  mobile: string;
  election_level: string | null;
  district_state: string | null;
  comment: string | null;
  status: string;
  created_at: string;
}

export interface PartnerRequestItem {
  id: string;
  name: string;
  phone: string;
  applying_for: string;
  state: string | null;
  comment: string | null;
  status: string;
  created_at: string;
}

export interface PagedList<T> {
  items: T[];
  total: number;
  limit: number;
  offset: number;
  loading: boolean;
  error: string | null;
}

export interface WebsiteFormState {
  queries: PagedList<QueryItem>;
  partnerRequests: PagedList<PartnerRequestItem>;
}

export type WebsiteFormListKey = keyof WebsiteFormState;

const emptyList = (): PagedList<any> => ({
  items: [],
  total: 0,
  limit: 10,
  offset: 0,
  loading: false,
  error: null,
});

const initialState: WebsiteFormState = {
  queries: emptyList(),
  partnerRequests: emptyList(),
};

const websiteFormSlice = createSlice({
  name: 'websiteForms',
  initialState,
  reducers: {
    setWebsiteFormLoading: (
      state,
      action: PayloadAction<{ key: WebsiteFormListKey; loading: boolean }>
    ) => {
      state[action.payload.key].loading = action.payload.loading;
    },
    setWebsiteFormError: (
      state,
      action: PayloadAction<{ key: WebsiteFormListKey; error: string | null }>
    ) => {
      state[action.payload.key].error = action.payload.error;
    },
    setWebsiteFormPage: (
      state,
      action: PayloadAction<{
        key: WebsiteFormListKey;
        items: any[];
        total: number;
        limit: number;
        offset: number;
      }>
    ) => {
      const { key, items, total, limit, offset } = action.payload;
      state[key].items = items;
      state[key].total = total;
      state[key].limit = limit;
      state[key].offset = offset;
    },
  },
});

export const { setWebsiteFormLoading, setWebsiteFormError, setWebsiteFormPage } =
  websiteFormSlice.actions;

export default websiteFormSlice.reducer;
